export default {"src":"/_next/static/media/apeswap.fb6a2ea0.svg","height":783,"width":798,"blurWidth":0,"blurHeight":0};